<div class="modal-header">
  <h4 class="modal-title">{{ dialogTitle }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="onDismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body modal-body--share" [formGroup]="form">
  <div *ngIf="loading" class="share-loading">
    Loading...
  </div>

  <div class="share-dual-list" *ngIf="!loading">
    <div class="share-layout">
      <section class="share-layout__left">
        <div class="share-panel">
          <div class="share-panel__header">
            <div>
              <div class="share-panel__title">Available items</div>
              <div class="share-panel__subtitle">
                Groups, businesses and items you can share
              </div>
            </div>

            <button
              type="button"
              class="share-top-btn share-top-btn--add"
              title="Add all"
              [disabled]="
                availablePagedGroups.length === 0 &&
                availablePagedBusinesses.length === 0 &&
                availablePagedRootItems.length === 0
              "
              (click)="addAllAvailable()"
            >
              <i class="fa fa-plus"></i>
              Add all
            </button>
          </div>

          <div class="share-panel__toolbar">
            <div class="share-search">
              <span class="share-search__icon">
                <i class="fas fa-search"></i>
              </span>

              <input
                type="text"
                class="form-control share-search__input"
                placeholder="Search groups, businesses or items..."
                (input)="onSearchAvailable($any($event.target).value)"
              />
            </div>

            <div class="share-filters">
              <button
                type="button"
                class="share-chip"
                [class.share-chip--active]="availableFilter === 'all'"
                (click)="setAvailableFilter('all')"
              >
                All
              </button>

              <button
                type="button"
                class="share-chip"
                [class.share-chip--active]="availableFilter === 'group'"
                (click)="setAvailableFilter('group')"
              >
                Groups
              </button>

              <button
                type="button"
                class="share-chip"
                [class.share-chip--active]="availableFilter === 'business'"
                (click)="setAvailableFilter('business')"
              >
                Businesses
              </button>

              <button
                type="button"
                class="share-chip"
                [class.share-chip--active]="availableFilter === 'item'"
                (click)="setAvailableFilter('item')"
              >
                Items
              </button>
            </div>
          </div>

          <div class="share-list">
            <div class="share-list__header">
              <div class="share-list__header-main">
                <span class="share-list__header-checkbox">
                  <input
                    type="checkbox"
                    [checked]="isAvailableHeaderChecked"
                    [indeterminate]="isAvailableHeaderIndeterminate"
                    (change)="toggleAvailableHeaderSelection($any($event.target).checked)"
                  />
                </span>

                <span>Item</span>
              </div>

              <div class="share-list__header-meta">Type</div>
            </div>

            <div class="share-list__scroll">
              <ng-container *ngFor="let group of availablePagedGroups; trackBy: trackByItem">
                <ng-container
                  *ngTemplateOutlet="availableGroupTpl; context: { $implicit: group }"
                ></ng-container>
              </ng-container>

              <ng-container *ngFor="let business of availablePagedBusinesses; trackBy: trackByItem">
                <ng-container
                  *ngTemplateOutlet="availableBusinessTpl; context: { $implicit: business, child: false }"
                ></ng-container>
              </ng-container>

              <ng-container *ngFor="let item of availablePagedRootItems; trackBy: trackByItem">
                <ng-container
                  *ngTemplateOutlet="availableItemTpl; context: { $implicit: item, child: false }"
                ></ng-container>
              </ng-container>

              <div
                class="share-list__empty"
                *ngIf="
                  availablePagedGroups.length === 0 &&
                  availablePagedBusinesses.length === 0 &&
                  availablePagedRootItems.length === 0
                "
              >
                <ng-container *ngIf="canAddManualItem; else noAvailableItemsTpl">
                  No item found with ID <strong>{{ manualItemId }}</strong>.
                  <br />

                  <button
                    type="button"
                    class="share-manual-add-btn"
                    (click)="addManualItem()"
                  >
                    <i class="fa fa-plus"></i>
                    <span>New item</span>
                  </button>
                </ng-container>

                <ng-template #noAvailableItemsTpl>
                  No items available to share.
                </ng-template>
              </div>
            </div>

            <div class="share-pagination" *ngIf="availableTotalPages > 1">
              <button
                type="button"
                class="share-page-btn"
                [disabled]="availablePageIndex === 0"
                (click)="goToPrevAvailablePage()"
              >
                ‹
              </button>

              <span class="share-page-info">
                Page {{ availablePageIndex + 1 }} / {{ availableTotalPages }}
              </span>

              <button
                type="button"
                class="share-page-btn"
                [disabled]="availablePageIndex >= availableTotalPages - 1"
                (click)="goToNextAvailablePage()"
              >
                ›
              </button>
            </div>
          </div>
        </div>
      </section>

      <aside class="share-layout__actions">
        <div class="share-actions">
          <button
            type="button"
            class="share-btn share-btn--add"
            [disabled]="!canAddSelectedItems"
            (click)="addSelected()"
          >
            Add &gt;&gt;
          </button>

          <button
            type="button"
            class="share-btn share-btn--remove"
            [disabled]="!canRemoveSelectedItems"
            (click)="removeSelected()"
          >
            &lt;&lt; Remove
          </button>
        </div>
      </aside>

      <section class="share-layout__right">
        <div class="share-panel">
          <div class="share-panel__header">
            <div>
              <div class="share-panel__title">Share with</div>
              <div class="share-panel__subtitle">
                Current recipients of this audience
              </div>
            </div>

            <button
              type="button"
              class="share-top-btn share-top-btn--remove"
              title="Remove all"
              [disabled]="selectedItems.length === 0"
              (click)="removeAllSelected()"
            >
              <i class="fa fa-trash"></i>
              Remove all
            </button>
          </div>

          <div class="share-panel__toolbar">
            <div class="share-search">
              <span class="share-search__icon">
                <i class="fas fa-search"></i>
              </span>

              <input
                type="text"
                class="form-control share-search__input"
                placeholder="Search selected items..."
                (input)="onSearchSelected($any($event.target).value)"
              />
            </div>
          </div>

          <div class="share-panel__summary" *ngIf="selectedItems.length">
            You are sharing with
            <strong>{{ selectedItems.length }}</strong>
            {{ selectedItems.length === 1 ? 'item' : 'items' }}.
          </div>

          <div class="share-list">
            <div class="share-list__header">
              <div class="share-list__header-main">Sharing with</div>
              <div class="share-list__header-meta">Actions</div>
            </div>

            <div class="share-list__scroll">
              <ng-container *ngFor="let group of selectedPagedGroups; trackBy: trackByItem">
                <ng-container
                  *ngTemplateOutlet="selectedGroupTpl; context: { $implicit: group }"
                ></ng-container>
              </ng-container>

              <ng-container *ngFor="let business of selectedPagedBusinesses; trackBy: trackByItem">
                <ng-container
                  *ngTemplateOutlet="selectedBusinessTpl; context: { $implicit: business, child: false }"
                ></ng-container>
              </ng-container>

              <ng-container *ngFor="let item of selectedPagedRootItems; trackBy: trackByItem">
                <ng-container
                  *ngTemplateOutlet="selectedItemTpl; context: { $implicit: item, child: false }"
                ></ng-container>
              </ng-container>

              <div
                class="share-list__empty"
                *ngIf="
                  selectedPagedGroups.length === 0 &&
                  selectedPagedBusinesses.length === 0 &&
                  selectedPagedRootItems.length === 0 &&
                  selectedItems.length === 0
                "
              >
                You are not yet sharing this audience with anyone
                <br />
                Add items from the list on the left
              </div>

              <div
                class="share-list__empty"
                *ngIf="
                  selectedPagedGroups.length === 0 &&
                  selectedPagedBusinesses.length === 0 &&
                  selectedPagedRootItems.length === 0 &&
                  selectedItems.length > 0
                "
              >
                No results found.
              </div>
            </div>

            <div class="share-pagination" *ngIf="selectedTotalPages > 1">
              <button
                type="button"
                class="share-page-btn"
                [disabled]="selectedPageIndex === 0"
                (click)="goToPrevSelectedPage()"
              >
                ‹
              </button>

              <span class="share-page-info">
                Page {{ selectedPageIndex + 1 }} / {{ selectedTotalPages }}
              </span>

              <button
                type="button"
                class="share-page-btn"
                [disabled]="selectedPageIndex >= selectedTotalPages - 1"
                (click)="goToNextSelectedPage()"
              >
                ›
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!canShare"
    (click)="onAccept()"
  >
    Share
  </button>

  <button type="button" class="btn btn-secondary" (click)="onDismiss()">
    Cancel
  </button>
</div>

<!-- Available templates -->
<ng-template #availableGroupTpl let-group>
  <div
    class="share-list-item share-list-item--group"
    (click)="onGroupRowClick($event, group)"
  >
    <div class="share-list-item__checkbox">
      <input
        type="checkbox"
        [checked]="isAvailableSelected(group)"
        [disabled]="getGroupItemsCount(group) === 0"
        (click)="$event.stopPropagation()"
        (change)="toggleGroupSelection(group, $any($event.target).checked)"
      />
    </div>

    <div class="share-list-item__content">
      <div class="share-list-item__main">
        <div class="share-list-item__main-left">
          <button
            type="button"
            class="share-tree-toggle"
            (click)="onGroupRowClick($event, group); $event.stopPropagation()"
          >
            <i
              class="fas"
              [ngClass]="{
                'fa-chevron-right': !isGroupExpanded(group),
                'fa-chevron-down': isGroupExpanded(group)
              }"
            ></i>
          </button>

          <span class="share-list-item__label">{{ group.name }}</span>
        </div>

        <span class="share-badge share-badge--group">
          {{ getItemTypeLabel(group) }}
        </span>
      </div>

      <div class="share-list-item__meta" *ngIf="getGroupItemsCount(group) as count">
        <span class="share-list-item__meta-count" *ngIf="count > 0">
          {{ count }} items
        </span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isGroupExpanded(group)">
    <ng-container *ngFor="let business of getBusinesses(group); trackBy: trackByItem">
      <ng-container
        *ngTemplateOutlet="availableBusinessTpl; context: { $implicit: business, child: true }"
      ></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #availableBusinessTpl let-business let-child="child">
  <div
    class="share-list-item"
    [class.share-list-item--child]="child"
    (click)="onBusinessRowClick($event, business)"
  >
    <div class="share-list-item__checkbox">
      <input
        type="checkbox"
        [checked]="isAvailableSelected(business)"
        [disabled]="getBusinessItemsCount(business) === 0"
        (click)="$event.stopPropagation()"
        (change)="toggleBusinessSelection(business, $any($event.target).checked)"
      />
    </div>

    <div class="share-list-item__content">
      <div class="share-list-item__main">
        <div class="share-list-item__main-left">
          <button
            type="button"
            class="share-tree-toggle"
            (click)="onBusinessRowClick($event, business); $event.stopPropagation()"
          >
            <i
              class="fas"
              [ngClass]="{
                'fa-chevron-right': !isBusinessExpanded(business),
                'fa-chevron-down': isBusinessExpanded(business)
              }"
            ></i>
          </button>

          <span class="share-list-item__label">{{ business.name }}</span>
        </div>

        <span class="share-badge share-badge--group">
          {{ getItemTypeLabel(business) }}
        </span>
      </div>

      <div class="share-list-item__meta" *ngIf="getBusinessItemsCount(business) as count">
        <span class="share-list-item__meta-count" *ngIf="count > 0">
          {{ count }} items
        </span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isBusinessExpanded(business)">
    <ng-container *ngFor="let item of getBusinessItems(business); trackBy: trackByItem">
      <ng-container
        *ngTemplateOutlet="availableItemTpl; context: { $implicit: item, child: true }"
      ></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #availableItemTpl let-item let-child="child">
  <div
    class="share-list-item"
    [class.share-list-item--child]="child"
    (click)="onAvailableItemRowClick($event, item)"
  >
    <div class="share-list-item__checkbox">
      <input
        type="checkbox"
        [checked]="isAvailableSelected(item)"
        [disabled]="item.selected"
        (click)="$event.stopPropagation()"
        (change)="toggleAvailableSelection(item, $any($event.target).checked)"
      />
    </div>

    <div class="share-list-item__content">
      <div class="share-list-item__main">
        <div class="share-list-item__main-left">
          <span class="share-list-item__label">{{ item.name }}</span>
        </div>

        <span class="share-badge share-badge--advertiser">
          {{ getItemTypeLabel(item) }}
        </span>
      </div>

      <div class="share-list-item__meta">
        Id: {{ item.id }}
      </div>
    </div>
  </div>
</ng-template>

<!-- Selected templates -->
<ng-template #selectedGroupTpl let-group>
  <div
    class="share-list-item share-list-item--selected share-list-item--group"
    [class.share-list-item--error]="hasGroupChildError(group)"
    (click)="onSelectedGroupRowClick($event, group)"
  >
    <div class="share-list-item__checkbox">
      <input
        type="checkbox"
        [checked]="isSelectedSelected(group)"
        (click)="$event.stopPropagation()"
        (change)="toggleSelectedSelection(group, $any($event.target).checked)"
      />
    </div>

    <div class="share-list-item__content">
      <div class="share-list-item__main">
        <div class="share-list-item__main-left">
          <button
            type="button"
            class="share-tree-toggle"
            (click)="onSelectedGroupRowClick($event, group); $event.stopPropagation()"
          >
            <i
              class="fas"
              [ngClass]="{
                'fa-chevron-right': !isSelectedGroupExpanded(group),
                'fa-chevron-down': isSelectedGroupExpanded(group)
              }"
            ></i>
          </button>

          <span class="share-list-item__label">{{ group.name }}</span>

          <ng-container
            *ngTemplateOutlet="warningTpl; context: { show: hasGroupChildError(group), message: getGroupErrorTooltip(group) }"
          ></ng-container>
        </div>

        <span class="share-badge share-badge--group">
          {{ getItemTypeLabel(group) }}
        </span>
      </div>

      <div class="share-meta-row" *ngIf="getSelectedChildrenCount(group) as count">
        <span class="share-meta-left">
          {{ count }} {{ count === 1 ? 'item' : 'items' }}
        </span>

        <button
          type="button"
          class="btn btn-link btn-sm share-remove-btn"
          title="Remove"
          (click)="removeSingle(group); $event.stopPropagation()"
        >
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isSelectedGroupExpanded(group)">
    <ng-container *ngFor="let business of getSelectedBusinesses(group); trackBy: trackByItem">
      <ng-container
        *ngTemplateOutlet="selectedBusinessTpl; context: { $implicit: business, child: true }"
      ></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #selectedBusinessTpl let-business let-child="child">
  <div
    class="share-list-item share-list-item--selected"
    [class.share-list-item--child]="child"
    [class.share-list-item--error]="hasBusinessChildError(business)"
    (click)="onSelectedBusinessRowClick($event, business)"
  >
    <div class="share-list-item__checkbox">
      <input
        type="checkbox"
        [checked]="isSelectedSelected(business)"
        (click)="$event.stopPropagation()"
        (change)="toggleSelectedSelection(business, $any($event.target).checked)"
      />
    </div>

    <div class="share-list-item__content">
      <div class="share-list-item__main">
        <div class="share-list-item__main-left">
          <button
            type="button"
            class="share-tree-toggle"
            (click)="onSelectedBusinessRowClick($event, business); $event.stopPropagation()"
          >
            <i
              class="fas"
              [ngClass]="{
                'fa-chevron-right': !isSelectedBusinessExpanded(business),
                'fa-chevron-down': isSelectedBusinessExpanded(business)
              }"
            ></i>
          </button>

          <span class="share-list-item__label">{{ business.name }}</span>

          <ng-container
            *ngTemplateOutlet="warningTpl; context: { show: hasBusinessChildError(business), message: getBusinessErrorTooltip(business) }"
          ></ng-container>
        </div>

        <span class="share-badge share-badge--group">
          {{ getItemTypeLabel(business) }}
        </span>
      </div>

      <div class="share-meta-row" *ngIf="getSelectedBusinessChildrenCount(business) as count">
        <span class="share-meta-left">
          {{ count }} {{ count === 1 ? 'item' : 'items' }}
        </span>

        <button
          type="button"
          class="btn btn-link btn-sm share-remove-btn"
          title="Remove"
          (click)="removeSingle(business); $event.stopPropagation()"
        >
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isSelectedBusinessExpanded(business)">
    <ng-container *ngFor="let item of getSelectedItemsFromBusiness(business); trackBy: trackByItem">
      <ng-container
        *ngTemplateOutlet="selectedItemTpl; context: { $implicit: item, child: true }"
      ></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #selectedItemTpl let-item let-child="child">
  <div
    class="share-list-item share-list-item--selected"
    [class.share-list-item--child]="child"
    [class.share-list-item--error]="hasItemError(item)"
    (click)="onSelectedItemRowClick($event, item)"
  >
    <div class="share-list-item__checkbox">
      <input
        type="checkbox"
        [checked]="isSelectedSelected(item)"
        (click)="$event.stopPropagation()"
        (change)="toggleSelectedSelection(item, $any($event.target).checked)"
      />
    </div>

    <div class="share-list-item__content">
      <div class="share-list-item__main">
        <div class="share-list-item__main-left">
          <span class="share-list-item__label">{{ item.name }}</span>
        </div>

        <span class="share-badge share-badge--advertiser">
          {{ getItemTypeLabel(item) }}
        </span>
      </div>

      <div class="share-meta-row">
        <div class="share-meta-ids">
          <span class="share-meta-left"
            [class.share-meta-left--error]="hasItemError(item)"
            [attr.title]="hasItemError(item) ? getItemErrorMessage(item) : null"
          >
            Id: {{ item.id }}
          </span>
          <span class="share-meta-left"
            [class.share-meta-left--error]="hasItemError(item)"
            [attr.title]="hasItemError(item) ? getItemErrorMessage(item) : null"
            *ngIf="!!item.audienceId"
          >
            AudienceId: {{ item.audienceId }}
          </span>
          <span
            *ngIf="hasItemError(item) && getItemErrorMessage(item)"
            class="share-inline-error"
            [attr.title]="getItemErrorMessage(item)"
          >
            - {{ getItemErrorMessage(item) }}
          </span>
        </div>
        <button
          type="button"
          class="btn btn-link btn-sm share-remove-btn"
          title="Remove"
          (click)="removeSingle(item); $event.stopPropagation()"
        >
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #warningTpl let-show="show" let-message="message">
  <span *ngIf="show" class="share-warning-icon" [attr.title]="message">
    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
  </span>
</ng-template>